import { Truck, Bus } from "lucide-react";
import { FadeUp } from "./Reveal";
import { useLang } from "@/lib/i18n";

export const Moto = (p) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <circle cx="5" cy="16" r="3.5" /><circle cx="19" cy="16" r="3.5" />
    <path d="M5 16l3.5-5h7.5l3 5M8.5 11l1.5-2.5h4l2 2.5M16 8h2.5l1 2M11 16h3" />
    <path d="M9 11h7" strokeWidth="3" />
  </svg>
);

export const Van = (p) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <path d="M2 16V7a1 1 0 0 1 1-1h11l5 4h2a1 1 0 0 1 1 1v5h-2M5 16H2M9 16h6" />
    <path d="M14 6v4h5M8 6v4" /><circle cx="7" cy="16.5" r="2" /><circle cx="17" cy="16.5" r="2" />
  </svg>
);

const ICONS = [Moto, Van, Truck, Bus];

export const VehicleTypes = () => {
  const { t } = useLang();
  const v = t.vehicles;
  return (
    <FadeUp className="mt-4">
      <div data-testid="vehicle-types" className="grid grid-cols-1 items-center gap-6 border border-white/10 bg-coal p-6 md:grid-cols-12 md:p-8">
        <div className="md:col-span-4">
          <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-brand2">{v.kicker}</div>
          <h3 className="font-display mt-2 text-xl font-extrabold uppercase leading-tight text-bone md:text-2xl">{v.title}</h3>
        </div>
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 md:col-span-8">
          {v.items.map((name, i) => {
            const Icon = ICONS[i];
            return (
              <div key={name} data-testid={`vehicle-type-${i}`} className="group flex flex-col items-center gap-3 border border-white/10 bg-ink px-3 py-5 text-center transition-colors duration-300 hover:border-brand hover:bg-brand hover:text-cream">
                <Icon className="h-9 w-9 text-brand transition-colors group-hover:text-cream" />
                <span className="font-display text-sm font-extrabold uppercase">{name}</span>
              </div>
            );
          })}
        </div>
      </div>
    </FadeUp>
  );
};
